import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {concat, Observable, Subscription} from "rxjs";
import {
  SystemUserRole
} from "../../../../store/entities/system-configurations/temp-fcrs/system-user-role/system-user-role.model";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../store";
import {GraphqlService} from "../../../../services/graphql.service";
import {ActivatedRoute} from "@angular/router";
import {NotificationService} from "../../../../services/notification.service";
import {BaseResponse} from "../../../../common/interfaces/global-interfaces";
import {
  SystemUserRoleActions
} from "../../../../store/entities/system-configurations/temp-fcrs/system-user-role/system-user-role.actions";
import {GET_ALL_SYSTEM_PERMISSIONS, GroupedPermission} from "./system-permissions";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {MatCheckboxChange} from "@angular/material/checkbox";
import {fadeIn} from "../../../../shared/animations/basic-animation";
import {SettingsService} from "../../../../services/settings.service";
import {
  selectSystemUserRoleByUuid
} from "../../../../store/entities/system-configurations/temp-fcrs/system-user-role/system-user-role.selectors";
import {UPDATE_USER_ROLES_MUTATION} from "../../../../store/entities/user-management/user-role/user-role.graphql";
import {delay} from "rxjs/operators";

@Component({
  selector: 'app-system-roles-view',
  templateUrl: './system-roles-view.component.html',
  styleUrl: './system-roles-view.component.scss',
  animations: [fadeIn]
})
export class SystemRolesViewComponent implements OnInit, OnDestroy {

  @Output()
  onClose = new EventEmitter<any>()

  selectedRole$: Observable<SystemUserRole>;
  selectedRole: SystemUserRole;

  routeSub = Subscription.EMPTY;
  selectedUuid: string

  isLoading: boolean = false

  allPermissions: GroupedPermission[]
  allPermissionsNew: GroupedPermission[]

  permissionsForm: FormGroup;
  formChanged: boolean;
  selectedPermissions: string[] = [];

  dataToExport: any;
  selectedSub: Subscription = new Subscription();


  constructor(
      private store: Store<AppState>,
      private apollo: GraphqlService,
      private activeRoute: ActivatedRoute,
      private settingsService: SettingsService,
      private notificationService: NotificationService,
      private fb: FormBuilder
  ) {
    this.store.dispatch(SystemUserRoleActions.getAllRoles({filter: {uniqueId: null}}));
  }

  get permissions(): FormArray {
    return this.permissionsForm.get('permissions') as FormArray;
  }

  async ngOnInit() {

   this.routeSub = this.activeRoute.queryParams.subscribe(items => {
  this.selectedUuid = items['id'] ?? '';

  console.log('Query param id received in view component:', this.selectedUuid);

  if (this.selectedUuid) {


    this.store.dispatch(SystemUserRoleActions.getAllRoles({ filter: { uniqueId: this.selectedUuid } }));

    this.selectedRole$ = this.store.select(selectSystemUserRoleByUuid(this.selectedUuid));
    this.selectedSub.add(
      this.selectedRole$.subscribe(d => {
        if (d) {
          console.log('Selected role from store:', d);
          this.selectedRole = d;
          this.selectedPermissions = [...d.permissions.map(p => p.uniqueId)];
        } else {
          console.log('No role found yet for this UUID');
        }
      })
    )
  }
});

    await this.loadAllSystemPermissions()


  }

  searchServiceType($event) {
    if ($event.target.value) {

      const y = this.allPermissions.map(d => {
        return {
          ...d,
          groupPermissions: d?.groupPermissions?.filter(perm => perm?.permissionName.replace(/_/g, ' ')?.toLowerCase().includes($event.target.value?.toLowerCase()))
        }
      })
      this.allPermissionsNew = y;
    } else {
      this.allPermissionsNew = this.allPermissions;
    }
  }

  async loadAllSystemPermissions() {
    this.isLoading = true;

    let isGlobal = this.activeRoute.snapshot.data['isGlobal']

    try {
      const response: any = await this.apollo.query({
        query: GET_ALL_SYSTEM_PERMISSIONS,
        variables: {
          filtering: {
            isGlobal
          }
        }
      });

      const result: BaseResponse<GroupedPermission[]> = Object.values(Object.values(response)[0])[0];

      if (result?.response?.status) {
        this.allPermissions = [...result?.data]
        this.allPermissionsNew = this.allPermissions;
        this.isLoading = false
      } else {
        throw Error(result.response.message);
      }
    } catch (e) {
      this.notificationService.errorMessage(e.message)
    }

    this.isLoading = false;
  }

  hasPermission(permission: string): boolean {
    return this.selectedPermissions.indexOf(permission) > -1;
  }

  onChange(uniqueId: string, $event: MatCheckboxChange) {
    this.formChanged = true;
    if ($event.checked) {
      const index = this.selectedPermissions.indexOf(uniqueId);
      if (index < 0) {
        this.selectedPermissions.push(uniqueId);
      }
    } else {
      const index = this.selectedPermissions.indexOf(uniqueId);
      if (index > -1) {
        this.selectedPermissions.splice(index, 1);
      }
    }
  }

  async saveChanges() {
    this.isLoading = true;

    try {

      const response: any = await this.apollo.mutate({
        mutation: UPDATE_USER_ROLES_MUTATION,
        variables: {
          input: {
            uniqueId: this.selectedUuid,
            roleName: this.selectedRole.roleName,
            rolePermissions: this.selectedPermissions
          }
        }
      });

      const result: BaseResponse<SystemUserRole> = Object.values(Object.values(response)[0])[0];

      if (result?.response?.status) {
        let responseData: SystemUserRole = result?.data
        this.store.dispatch(SystemUserRoleActions.upsertSystemUserRole({systemUserRole: responseData}));
        this.isLoading = false
        this.notificationService.successMessage(result?.response.message)
      } else {
        throw Error(result.response.message);
      }
    } catch (e) {
      this.notificationService.errorMessage(e.message)
    }

    this.isLoading = false;
  }


  ngOnDestroy() {
    this.routeSub.unsubscribe()
  }

  formatPermissionName(name: string): string {
    if (!name) return name;
    const words = name.split('_').filter(word => word.toLowerCase() !== 'can');
    return words
      .map((word, index) => 
        index === 0 
          ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join('');
  }


}
